import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../index'

interface ConfidenceRanges {
  high: number
  medium: number
  low: number
}

export interface UISettingsState {
  confidenceThresholds: ConfidenceRanges
}

const DEFAULT_RANGES: ConfidenceRanges = {
  high: 0.8,
  medium: 0.5,
  low: 0.1,
}

const initialState: UISettingsState = {
  confidenceThresholds: DEFAULT_RANGES,
}

const uiSettingsSlice = createSlice({
  name: 'uiSettings',
  initialState,
  reducers: {
    setConfidenceThresholds: (state, action: PayloadAction<ConfidenceRanges>) => {
      state.confidenceThresholds = action.payload
    },
    resetConfidenceThresholds: (state) => {
      state.confidenceThresholds = DEFAULT_RANGES
    },
  },
})

export const { setConfidenceThresholds, resetConfidenceThresholds } = uiSettingsSlice.actions

export const selectConfidenceThresholds = (state: RootState) =>
  state.uiSettings.confidenceThresholds

export default uiSettingsSlice.reducer
